( function ( $ ) {
	'use strict';

	const searchFilterType = 'product_title_search';
	const dieCutTypeFilterType = 'aconvert_die_cut_type';
	const resultCountAction = 'aconvert_composite_component_options_result_count';

	function getSelectedConstrainedDieCutProductId( component ) {
		const config = window.AconvertCompositeThicknessFilter || {};
		const constraints = config.dieCutGsmConstraints || {};
		const composite = component.composite;

		if ( ! composite || typeof composite.get_components !== 'function' ) {
			return 0;
		}

		let selectedProductId = 0;

		composite.get_components().some( function ( candidate ) {
			if (
				typeof candidate.get_selected_product !== 'function' ||
				! candidate.component_selection_model ||
				typeof candidate.component_selection_model.get !== 'function'
			) {
				return false;
			}

			const productId = parseInt( candidate.get_selected_product( false ), 10 );
			if ( productId && constraints[ productId ] ) {
				selectedProductId = productId;
				return true;
			}

			return false;
		} );

		return selectedProductId;
	}

	function debounce( callback, delay ) {
		let timer = null;

		return function () {
			const context = this;
			const args = arguments;

			clearTimeout( timer );
			timer = setTimeout( function () {
				callback.apply( context, args );
			}, delay );
		};
	}

	function getComponentSearchTerm( component ) {
		const $search = component.$el.find( '.aconvert-component-options-search-input' ).first();

		return $search.length ? String( $search.val() || '' ).trim() : '';
	}

	function patchComponentFilters( component ) {
		if ( component.aconvertSearchPatched || typeof component.find_active_filters !== 'function' ) {
			return;
		}

		const findActiveFilters = component.find_active_filters;

		component.find_active_filters = function () {
			const filters = findActiveFilters.call( component ) || {};
			const searchTerm = getComponentSearchTerm( component );
			const dieCutTypeProductId = getSelectedConstrainedDieCutProductId( component );

			if ( searchTerm ) {
				filters[ searchFilterType ] = {
					term: [ searchTerm ],
				};
			} else if ( filters[ searchFilterType ] ) {
				delete filters[ searchFilterType ];
			}

			if ( dieCutTypeProductId ) {
				filters[ dieCutTypeFilterType ] = {
					product_id: [ dieCutTypeProductId ],
				};
			} else if ( filters[ dieCutTypeFilterType ] ) {
				delete filters[ dieCutTypeFilterType ];
			}

			return filters;
		};

		component.aconvertSearchPatched = true;
	}

	function ensureComponentSearchControl( component ) {
		if ( ! component.$component_options || component.$el.find( '.aconvert-component-options-search' ).length ) {
			return;
		}

		const componentId = component.component_id || component.step_id || Math.floor( Math.random() * 100000 );
		const inputId = 'aconvert-component-options-search-' + componentId;
		const $control = $(
			'<div class="aconvert-component-options-search">' +
				'<label class="aconvert-component-options-search-label" for="' + inputId + '">Search options</label>' +
				'<input id="' + inputId + '" class="aconvert-component-options-search-input" type="search" autocomplete="off" placeholder="Search by product title">' +
			'</div>'
		);

		const $sidebar = component.$el.find( '.aconvert-component-options-sidebar' ).first();
		if ( $sidebar.length ) {
			$sidebar.append( $control );
			return;
		}

		const $insertAfter = component.$el.find( '.component_filters, .component_ordering' ).last();

		if ( $insertAfter.length ) {
			$control.insertAfter( $insertAfter );
		} else {
			$control.insertBefore( component.$component_options );
		}
	}

	function bindComponentSearch( component ) {
		if ( component.aconvertSearchBound || ! component.component_options_view ) {
			return;
		}

		const updateOptions = debounce( function () {
			const view = component.component_options_view;

			if ( ! view || typeof view.update_options !== 'function' ) {
				return;
			}

			component.$component_options.addClass( 'refresh_component_options' );
			view.$blocked_element = component.$component_options;
			view.update_options(
				{
					page: 1,
					filters: component.find_active_filters(),
					orderby: component.find_order_by(),
				},
				'reload'
			);
		}, 300 );

		component.$el.on( 'input', '.aconvert-component-options-search-input', updateOptions );
		component.$el.on( 'keydown', '.aconvert-component-options-search-input', function ( event ) {
			if ( event.key !== 'Enter' ) {
				return;
			}

			// Keep Enter in search from activating the form's first submit button.
			event.preventDefault();
			event.stopPropagation();
			updateOptions();
		} );
		component.$el.find( '.component_filter_title button.aria_button' ).attr( 'type', 'button' );
		component.aconvertSearchBound = true;
	}

	function getResultCountPage( component ) {
		const model = component.component_options_model;

		if ( model && typeof model.get === 'function' && model.get( 'page' ) ) {
			return model.get( 'page' );
		}

		if ( typeof component.find_pagination_param === 'function' ) {
			return component.find_pagination_param( 'page' );
		}

		return 1;
	}

	function getResultCountAjaxUrl() {
		if ( window.aconvertTheme && window.aconvertTheme.ajaxUrl ) {
			return window.aconvertTheme.ajaxUrl;
		}

		if ( window.woocommerce_params && window.woocommerce_params.ajax_url ) {
			return window.woocommerce_params.ajax_url;
		}

		return '';
	}

	function updateComponentResultCount( component ) {
		const $count = component.$el.find( '.aconvert-component-options-result-count' ).first();
		const ajaxUrl = getResultCountAjaxUrl();

		if ( ! $count.length || ! ajaxUrl || ! component.component_options_model ) {
			return;
		}

		const model = component.component_options_model;
		const filters = typeof model.get === 'function' ? model.get( 'filters' ) : {};

		const data = {
			action: resultCountAction,
			component_id: component.component_id,
			composite_id: component.composite_id || ( component.composite && component.composite.composite_id ),
			load_page: getResultCountPage( component ),
			selected_option: typeof component.get_selected_product === 'function' ? component.get_selected_product( false ) : '',
			filters: filters,
			orderby: typeof model.get === 'function' ? model.get( 'orderby' ) : '',
			options_in_scenarios: typeof model.get === 'function' ? model.get( 'options_in_scenarios' ) : [],
		};

		if ( ! data.component_id || ! data.composite_id ) {
			return;
		}

		const requestKey = JSON.stringify( data );
		if ( component.aconvertResultCountRequestKey === requestKey ) {
			return;
		}

		if ( component.aconvertResultCountXhr ) {
			component.aconvertResultCountXhr.abort();
		}

		component.aconvertResultCountRequestKey = requestKey;
		component.aconvertResultCountXhr = $.post( ajaxUrl, data, function ( response ) {
			// A selection can change while either the product or facet request is in flight.
			if (
				component.aconvertResultCountRequestKey !== requestKey ||
				JSON.stringify( component.find_active_filters() || {} ) !== JSON.stringify( filters || {} )
			) {
				return;
			}

			if ( response && response.success && response.data && response.data.text ) {
				$count.text( response.data.text );
				updateComponentFilterAvailability( component, response.data.available_filters );
			} else {
				component.aconvertResultCountRequestKey = null;
			}
		} ).fail( function () {
			if ( component.aconvertResultCountRequestKey === requestKey ) {
				component.aconvertResultCountRequestKey = null;
			}
		} );
	}

	function updateComponentFilterAvailability( component, availableFilters ) {
		if ( ! availableFilters || typeof availableFilters !== 'object' ) {
			return;
		}

		component.$el.find( '.component_filter' ).each( function () {
			const $filter = $( this );
			const taxonomy = $filter.data( 'filter_id' );
			if ( $filter.data( 'filter_type' ) !== 'attribute_filter' || ! Array.isArray( availableFilters[ taxonomy ] ) ) {
				return;
			}

			const available = new Set( availableFilters[ taxonomy ].map( String ) );
			$filter.find( '.component_filter_option' ).each( function () {
				const $option = $( this );
				// Keep selected options available for removal, including conflicting selections.
				$option.toggle( $option.hasClass( 'selected' ) || available.has( String( $option.data( 'option_id' ) ) ) );
			} );
		} );
	}

	function enhanceCompositeSearch( composite ) {
		if ( ! composite || typeof composite.get_components !== 'function' ) {
			return;
		}

		composite.get_components().forEach( function ( component ) {
			patchComponentFilters( component );
			ensureComponentSearchControl( component );
			bindComponentSearch( component );
			updateComponentResultCount( component );
		} );
	}

	function refreshPaperOptionsForTypeSelection( changedComponent ) {
		if ( ! changedComponent || typeof changedComponent.get_selected_product !== 'function' ) {
			return;
		}

		const composite = changedComponent.composite;
		const config = window.AconvertCompositeThicknessFilter || {};
		const constraints = config.dieCutGsmConstraints || {};
		const selectedProductId = parseInt( changedComponent.get_selected_product( false ), 10 );
		const previousProductId = parseInt( changedComponent.aconvertPreviousConstrainedProductId, 10 );

		if ( selectedProductId && constraints[ selectedProductId ] ) {
			if ( selectedProductId === previousProductId ) {
				return;
			}

			changedComponent.aconvertPreviousConstrainedProductId = selectedProductId;
		} else if ( previousProductId && constraints[ previousProductId ] ) {
			changedComponent.aconvertPreviousConstrainedProductId = 0;
		} else {
			return;
		}

		if ( ! composite || typeof composite.get_components !== 'function' ) {
			return;
		}

		setTimeout( function () {
			composite.get_components().forEach( function ( component ) {
				if (
					component === changedComponent ||
					! component.component_options_view ||
					typeof component.component_options_view.update_options !== 'function'
				) {
					return;
				}

				component.$component_options.addClass( 'refresh_component_options' );
				component.component_options_view.$blocked_element = component.$component_options;
				component.component_options_view.update_options(
					{
						page: 1,
						filters: component.find_active_filters(),
						orderby: component.find_order_by(),
					},
					'reload'
				);
			} );
		}, 0 );
	}

	function bindCompositeDynamicFilters( composite ) {
		if ( ! composite || composite.aconvertDynamicFiltersBound || ! composite.actions ) {
			return;
		}

		composite.actions.add_action(
			'initialize_composite',
			function () {
				if ( typeof composite.get_components !== 'function' ) {
					return;
				}

				composite.get_components().forEach( function ( component ) {
					patchComponentFilters( component );
				} );
			},
			15,
			composite
		);
		composite.actions.add_action(
			'component_selection_changed',
			refreshPaperOptionsForTypeSelection,
			120,
			composite
		);

		composite.aconvertDynamicFiltersBound = true;
	}

	function enhanceCompositeForms() {
		$( '.composite_form' ).each( function () {
			const composite = $( this ).wc_get_composite_script ? $( this ).wc_get_composite_script() : false;

			enhanceCompositeSearch( composite );
		} );
	}

	function updateDieCutsNumberPerSheet( $variationForm, variation, productTitle ) {
		const $compositeForm = $variationForm.closest( '.composite_form' );
		const $output = $compositeForm.find( '.composite_wrap .aconvert-number-per-sheet' ).first();

		if ( ! $output.length ) {
			return;
		}

		const variationValues = $output.data( 'variationValues' ) || {};
		const variationId = variation ? parseInt( variation.variation_id, 10 ) : 0;
		const numberPerSheet = variationId ? parseInt( variationValues[ variationId ], 10 ) : 0;
		const $sheetQuantity = $compositeForm.find( '.aconvert-sheet-quantity' );
		const $pieces = $compositeForm.find( '.composite_wrap input.qty[name="quantity"]' );
		if ( numberPerSheet && ! $pieces.data( 'aconvertInitialized' ) ) {
			$pieces.val( Number( $output.data( 'requestedPieces' ) ) || ( parseInt( $sheetQuantity.val(), 10 ) || 1 ) * numberPerSheet );
			$pieces.data( 'aconvertInitialized', true );
		}
		const requested = Number( $pieces.val() );
		const minimumSheets = Math.max( 1, Number( $sheetQuantity.attr( 'min' ) ) || 1 );
		const quantity = numberPerSheet && Number.isInteger( requested ) && requested > 0
			? Math.max( minimumSheets, Math.ceil( requested / numberPerSheet ) ) : minimumSheets;
		const maxSheets = Number( $sheetQuantity.attr( 'max' ) );
		if ( numberPerSheet && maxSheets > 0 ) {
			$pieces.attr( 'max', maxSheets * numberPerSheet );
		} else {
			$pieces.removeAttr( 'max' );
		}
		const total = numberPerSheet * quantity;
		const $quantityMessages = $compositeForm.find( '.composite_wrap .aconvert-die-cuts-quantity-message' );
		const $productTitles = $compositeForm.find( '.composite_wrap .aconvert-die-cuts-product-title' );

		$output.find( '.aconvert-number-per-sheet-value' ).text( numberPerSheet || '' );
		$output.prop( 'hidden', ! numberPerSheet );
		$productTitles.text( productTitle || '' );
		$quantityMessages.find( '.aconvert-die-cuts-quantity' ).text( quantity );
		$quantityMessages.find( '.aconvert-die-cuts-total' ).text( total || '' );
		$quantityMessages.prop( 'hidden', ! numberPerSheet || ! productTitle );
		if ( Number( $sheetQuantity.val() ) !== quantity ) {
			$sheetQuantity.val( quantity );
			const composite = $compositeForm.wc_get_composite_script ? $compositeForm.wc_get_composite_script() : false;
			if ( composite && composite.data_model ) {
				composite.data_model.calculate_totals();
			}
		}
	}

	function updateDieCutsNumberPerSheetFromComponent( component ) {
		if ( ! component || typeof component.get_selected_product !== 'function' ) {
			return;
		}

		const $compositeForm = component.$el.closest( '.composite_form' );
		const $output = $compositeForm.find( '.composite_wrap .aconvert-number-per-sheet' ).first();
		const productIds = $output.data( 'productIds' ) || [];
		const selectedProductId = parseInt( component.get_selected_product( false ), 10 );
		const isDieCutsProduct = productIds.some( function ( productId ) {
			return parseInt( productId, 10 ) === selectedProductId;
		} );
		const $variationForm = component.$el.find( '.variations_form' ).first();

		if ( ! isDieCutsProduct ) {
			if ( component.aconvertDieCutsProductSelected ) {
				updateDieCutsNumberPerSheet( $variationForm, null, '' );
				component.aconvertDieCutsProductSelected = false;
			}

			return;
		}

		component.aconvertDieCutsProductSelected = true;

		const variationId = typeof component.get_selected_variation === 'function'
			? parseInt( component.get_selected_variation( false ), 10 )
			: 0;
		const productTitle = typeof component.get_selected_product_title === 'function'
			? component.get_selected_product_title( false )
			: '';

		updateDieCutsNumberPerSheet( $variationForm, { variation_id: variationId }, productTitle );
	}

	function bindDieCutsNumberPerSheetToComposite( composite ) {
		if (
			! composite ||
			composite.aconvertNumberPerSheetBound ||
			! composite.$composite_data ||
			! composite.$composite_data.find( '.aconvert-number-per-sheet' ).length ||
			! composite.actions
		) {
			return;
		}

		// Keep the native field in pieces. Composite Products reads this internal
		// sheet quantity for prices, stock validation and component multiplication.
		const $pieces = composite.$composite_quantity;
		const $output = composite.$composite_data.find( '.aconvert-number-per-sheet' ).first();
		const $sheets = $( '<input type="hidden" class="aconvert-sheet-quantity">' )
			.val( $pieces.val() )
			.attr( 'min', $pieces.attr( 'min' ) || 1 )
			.attr( 'max', $pieces.attr( 'max' ) || '' );
		$sheets.insertAfter( $pieces );
		composite.$composite_quantity = $sheets;
		$pieces.attr( { min: 1, step: 1, 'aria-label': $output.data( 'quantityLabel' ) } ).removeAttr( 'max' );
		$pieces.closest( '.quantity' ).find( 'label' ).text( $output.data( 'quantityLabel' ) );

		composite.actions.add_action(
			'component_selection_changed',
			updateDieCutsNumberPerSheetFromComponent,
			120,
			composite
		);
		composite.filters.add_filter(
			'component_selection_meta',
			function ( meta ) {
				return meta.filter( function ( item ) {
					const key = String( item.meta_key || '' ).trim().replace( /:\s*$/, '' ).toLowerCase();

					return key !== 'size' && key !== 'pack size';
				} );
			},
			20,
			composite
		);
		composite.aconvertNumberPerSheetBound = true;
	}

	function bindCompositePaperWastePricing( composite ) {
		const configs = window.wc_composite_params && window.wc_composite_params.aconvert_paper_waste_pricing;
		const config = configs && configs[ parseInt( composite && composite.composite_id, 10 ) ];

		if ( ! composite || composite.aconvertPaperWastePricingBound || ! composite.filters || ! config ) {
			return;
		}

		const percentage = Math.max( 0, Number( config.percentage ) || 0 );
		const minimumWasteSheets = Math.max( 0, parseInt( config.minimum_waste_sheets, 10 ) || 0 );
		const paperProductIds = Array.isArray( config.paper_product_ids )
			? config.paper_product_ids.map( function ( id ) { return parseInt( id, 10 ); } )
			: [];

		if ( percentage <= 0 || ! paperProductIds.length ) {
			return;
		}

		composite.filters.add_filter(
			'component_totals',
			function ( totals, component, quantity ) {
				const productId = component && typeof component.get_selected_product === 'function'
					? parseInt( component.get_selected_product( false ), 10 )
					: 0;

				if ( ! productId || paperProductIds.indexOf( productId ) === -1 ) {
					return totals;
				}

				const orderedSheets = Math.max( 1, Number( quantity ) || 1 );
				const percentageWaste = Math.ceil( orderedSheets * ( percentage / 100 ) );
				const billableSheets = orderedSheets + Math.max( minimumWasteSheets, percentageWaste );
				const selectionModel = component.component_selection_model;
				const variations = selectionModel && selectionModel.get_available_variations_data
					? selectionModel.get_available_variations_data() : [];
				const variationId = Number( component.get_selected_variation( false ) );
				const variation = Array.isArray( variations )
					? variations.find( function ( item ) { return Number( item.variation_id ) === variationId; } ) : null;
				const tiers = variation && variation.aconvert_csp_sheet_prices;
				const normalTiers = variation && variation.aconvert_partner_normal_sheet_prices;
				let sheetPrice = null;
				let normalSheetPrice = null;

				Object.keys( tiers || {} ).map( Number ).sort( function ( a, b ) { return a - b; } ).forEach( function ( minimum ) {
					if ( minimum <= billableSheets && Number.isFinite( Number( tiers[ minimum ] ) ) ) {
						sheetPrice = Number( tiers[ minimum ] );
						normalSheetPrice = normalTiers && Number.isFinite( Number( normalTiers[ minimum ] ) )
							? Number( normalTiers[ minimum ] ) : sheetPrice;
					}
				} );

				if ( sheetPrice !== null ) {
					const model = composite.data_model;
					return model.get_taxed_totals(
						sheetPrice, normalSheetPrice,
						model.price_data.price_tax_ratios[ component.component_id ], billableSheets
					);
				}

				const existingPercentageFactor = 1 + ( percentage / 100 );
				const scale = billableSheets / ( orderedSheets * existingPercentageFactor );

				[ 'price', 'regular_price', 'price_incl_tax', 'price_excl_tax' ].forEach( function ( key ) {
					totals[ key ] = ( Number( totals[ key ] ) || 0 ) * scale;
				} );

				return totals;
			},
			20,
			composite
		);

		composite.aconvertPaperWastePricingBound = true;
	}

	function bindCompositeQuantityPricing( composite ) {
		const params = window.wc_composite_params || {};
		const config = [
			params.aconvert_die_cuts_labor_pricing,
			params.aconvert_duplex_pricing,
			params.aconvert_triplex_labor_pricing,
		].find( function ( candidate ) {
			return candidate && composite && Number( candidate.product_id ) === Number( composite.composite_id );
		} );

		if (
			! composite ||
			composite.aconvertQuantityPricingBound ||
			! composite.filters ||
			! config ||
			parseInt( composite.composite_id, 10 ) !== parseInt( config.product_id, 10 )
		) {
			return;
		}

		composite.filters.add_filter(
			'composite_totals',
			function ( totals ) {
				const quantity = Math.max( 1, parseInt( composite.$composite_quantity.val(), 10 ) || 1 );
				const baseLaborPrice = Math.max( 0, Number( config.base_labor_price ) || 0 );
				const normalBaseLaborPrice = config.normal_base_labor_price === undefined
					? baseLaborPrice : Math.max( 0, Number( config.normal_base_labor_price ) || 0 );
				const includedQuantity = parseInt( config.included_quantity, 10 );

				if ( ! Number.isFinite( includedQuantity ) || includedQuantity <= 0 ) {
					return totals;
				}

				const model = composite.data_model;
				const priceData = model && model.price_data;

				if ( ! priceData ) {
					return totals;
				}

				// The stock composite total is for one item. Calculate the selected
				// sheet quantity through the same tax and paper-waste helpers.
				const laborTotal = baseLaborPrice * Math.max( 1, quantity / includedQuantity );
				const baseTotals = model.get_taxed_totals(
					laborTotal,
					normalBaseLaborPrice * Math.max( 1, quantity / includedQuantity ),
					priceData.base_price_tax_ratios,
					1
				);
				const keys = [ 'price', 'regular_price', 'price_incl_tax', 'price_excl_tax' ];

				keys.forEach( function ( key ) {
					totals[ key ] = baseTotals[ key ];
				} );

				composite.get_components().forEach( function ( component ) {
					const componentQuantity = ( Number( priceData.quantities[ component.component_id ] ) || 0 ) * quantity;
					const componentTotals = model.calculate_component_subtotals( component, priceData, componentQuantity );

					keys.forEach( function ( key ) {
						totals[ key ] += componentTotals[ key ];
					} );
				} );

				return totals;
			},
			20,
			composite
		);

		composite.aconvertQuantityPricingBound = true;
	}

	$( document.body ).on( 'removed_from_cart', function ( event, fragments ) {
		if ( fragments && fragments['div.widget_shopping_cart_content'] ) {
			$( '.woocommerce-mini-cart-wrapper' ).replaceWith(
				fragments['div.widget_shopping_cart_content']
			);
		}
	} );

	$( document ).on( 'wc-composite-initializing', function ( event, composite ) {
		composite.filters.add_filter(
			'component_selection_formatted_meta',
			function ( html ) {
				const $meta = $( '<div>' ).html( html );

				$meta.find( '.content_product_meta > li.meta_element' ).each( function () {
					const key = $( this ).children( '.meta_key' ).text().trim().replace( /:\s*$/, '' ).toLowerCase();

					if ( key === 'pack size' ) {
						$( this ).addClass( 'aconvert-pack-size-meta' );
					} else if ( key === 'size' ) {
						$( this ).addClass( 'aconvert-size-meta' );
					}
				} );

				return $meta.html();
			},
			20,
			composite
		);
		bindCompositeDynamicFilters( composite );
		bindDieCutsNumberPerSheetToComposite( composite );
		bindCompositePaperWastePricing( composite );
		bindCompositeQuantityPricing( composite );
		enhanceCompositeForms();
	} );

	$( document ).on( 'wc-composite-initialized wc-composite-component-options-loaded', function () {
		enhanceCompositeForms();
	} );

	$( document ).on( 'wc-composite-component-options-loaded', function ( event, component ) {
		updateComponentResultCount( component );
	} );

	$( document ).on( 'wc-composite-component-loaded', function ( event, component ) {
		updateDieCutsNumberPerSheetFromComponent( component );
	} );

	$( document ).on( 'woocommerce_update_variation_values', '.composited_product_details_wrapper .variations_form', function () {
		enhanceCompositeForms();
	} );

	$( document ).on( 'input change', '.composite_wrap input.qty[name="quantity"]', function () {
		const $compositeForm = $( this ).closest( '.composite_form' );
		const composite = $compositeForm.wc_get_composite_script ? $compositeForm.wc_get_composite_script() : false;

		if ( ! composite || typeof composite.get_components !== 'function' ) {
			return;
		}

		composite.get_components().forEach( function ( component ) {
			updateDieCutsNumberPerSheetFromComponent( component );
		} );

		if ( composite.aconvertQuantityPricingBound && composite.data_model ) {
			composite.data_model.calculate_totals();
		}
	} );

	$( function () {
		enhanceCompositeForms();
		setTimeout( enhanceCompositeForms, 250 );
		setTimeout( enhanceCompositeForms, 1000 );
	} );
} )( jQuery );
